import NavigationBar from '../NavigationBar/NavigationBar';
//import React from 'react';
import logo from '../../Assets/Images/logo_mtbcr.png';

export function HeaderMTB() {
    return(
        <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
            <table class='mtbcr_layout'>
                <tr>
                    <td>
                        <img src={logo} alt="MTB Costa Rica logo" className='App-logo-spin' width='150' height='150' />
                    </td>

                    <td>
                        <h1>
                            MTB Costa Rica
                        </h1>
                        <em>https://www.mtb.cr</em>
                    </td>
                </tr>

                <tr>
                    <td colspan='2'>

                        <NavigationBar></NavigationBar>

                    </td>
                </tr>
            </table>
            
        </div>
    );
}


